import * as React from "react";
import { useState, useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import debounce from "lodash/debounce";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
import { Button, Input } from "components/bootstrap";
const ABSKeySecretFieldGroup = ({ isKeySet, handleAccountKeyChange }) => {
  const { t } = useTranslation("enterprise_archive");
  const { setFieldValue } = useFormikContext();
  const [isCreate] = useState(() => !isKeySet);
  const [showResetPasswordButton, setShowResetPasswordButton] = useState(isKeySet);
  const setAccessKey = useCallback(
    (nextAccessKey) => {
      setFieldValue("settings.key", nextAccessKey);
    },
    [setFieldValue]
  );
  useEffect(() => {
    if (isKeySet) {
      setAccessKey({ keep_value: true });
    }
  }, [isKeySet, setAccessKey]);
  const toggleAccountKeyReset = useCallback(() => {
    if (showResetPasswordButton) {
      setAccessKey({ delete_value: true });
      setShowResetPasswordButton(false);
      return;
    }
    setAccessKey({ keep_value: true });
    setShowResetPasswordButton(true);
  }, [setAccessKey, showResetPasswordButton]);
  const debouncedHanldeAccountKeyChange = debounce(handleAccountKeyChange, 200);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.account_name",
      type: "text",
      label: t("azure_key_secret_field_group.account_label"),
      placeholder: t("azure_key_secret_field_group.account_placeholder"),
      help: t("azure_key_secret_field_group.account_help"),
      required: true,
      labelClassName: "",
      wrapperClassName: ""
    }
  ), showResetPasswordButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "azure_account_reset",
      label: t("azure_key_secret_field_group.account_key_reset_label"),
      labelClassName: "",
      wrapperClassName: ""
    },
    " ",
    /* @__PURE__ */ React.createElement(Button, { onClick: toggleAccountKeyReset }, t("azure_key_secret_field_group.reset_password"))
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      name: "settings.key",
      id: "key",
      type: "password",
      label: t("azure_key_secret_field_group.account_key_label"),
      onChange: ({ target: { value } }) => debouncedHanldeAccountKeyChange(value),
      buttonAfter: !isCreate ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleAccountKeyReset }, t("azure_key_secret_field_group.undo_reset")) : void 0,
      placeholder: "****************",
      help: t("azure_key_secret_field_group.account_key_help"),
      required: true
    }
  ));
};
export default ABSKeySecretFieldGroup;
